module.exports = __webpack_public_path__ + "heroku-logo.png";